import moment from "moment";

const IsChaseOverSix = (chase: any) => {
  return (
    moment
      .duration(moment(chase?.createdAt).diff(chase?.cancellationDate))
      .years() >= 6
  );
};

export default IsChaseOverSix;
